module.exports=function(scope){ return `<div id="${scope.id}" class="asseco-floaty">
    <ul class="asseco-toolbar-floaty-list">
        ${scope.listItems}
    </ul>

    <div class="asseco-floaty-btn">
        ${scope.startIcon}
        ${scope.activeIcon}
    </div>
</div>`};